import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { largeTitle as titleStyle } from '../../styles/theme';
import { questionAndAnswerType } from '../../propTypes/questionAndAnswer';
import {
  getSliceTitleAndTag,
  getSliceItems,
  getSliceFaqStructuredDataEnabled,
} from '../../selectors';
import Title from '../Title';
import FaqItem from './Item';
import FaqStructuredData from './FaqStructuredData';

const Faq = ({
  classes,
  title,
  titleTag,
  items,
  isStructuredDataEnabled,
}) => (
  <div>
    {isStructuredDataEnabled && <FaqStructuredData items={items} />}
    {title && (
      <Title className={classes.title} tag={titleTag}>
        {title}
      </Title>
    )}
    {items && items.map((item, i) => (
      <FaqItem key={i} item={item} /> // eslint-disable-line react/no-array-index-key
    ))}
  </div>
);

Faq.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  titleTag: PropTypes.string,
  items: PropTypes.arrayOf(questionAndAnswerType),
  isStructuredDataEnabled: PropTypes.bool,
};

Faq.defaultProps = {
  title: undefined,
  titleTag: 'h2',
  items: [],
  isStructuredDataEnabled: true,
};

const mapStateToProps = (state, { sliceId }) => ({
  ...getSliceTitleAndTag(state, sliceId),
  items: getSliceItems(state, sliceId),
  isStructuredDataEnabled: getSliceFaqStructuredDataEnabled(state, sliceId),
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    title: {
      ...titleStyle,
      marginBottom: 16,
      textAlign: 'center',
    },
  }),
)(Faq);
